/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useEffect, useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import * as S from "../../styles";

export interface INumberInputProps {
    id: string;
    label?: string;
    labelColor?: string;
    errorText?: string;
    disabled?: boolean;
    hasError?: boolean;
    groupText?: string;
    value?: string;
    required?: boolean;
    placeholder?: string;
    onCompChange?(id: string, payload: any): void;
    textBelow?: string;
    isnegativeAllowed?: boolean;
}

export const NumberInput = ({
    id,
    label,
    labelColor,
    errorText,
    hasError,
    groupText,
    value,
    required,
    disabled,
    placeholder,
    onCompChange,
    textBelow,
    isnegativeAllowed = true,
}: INumberInputProps) => {
    const sanitizeValue = (val: any) => {
        if (isnegativeAllowed === false && val !== "" && val !== undefined && val !== null) {
            const num = Number(val);
            if ((!isNaN(num) && num < 0) || (typeof val === "string" && val.trim().startsWith("-"))) {
                return "0";
            }
        }
        return val;
    };

    const [textValue, setTextValue] = useState(sanitizeValue(value) ?? "");
    const [isInvalid, setInvalid] = useState(false);

    useEffect(() => {
        if (hasError) {
            setInvalid(true);
        }
    }, [hasError]);


    useEffect(() => {
        setTextValue(sanitizeValue(value));
    }, [value, isnegativeAllowed]);

    const onChange = (id: string, e: any) => {
        let val = e?.target?.value;
        val = sanitizeValue(val);
        setTextValue(val);
        onCompChange && onCompChange(id, val);
    };

    const _renderLabelIf = () => {
        if (label) {
            return (
                <S.FormLabel color={labelColor}>
                    {label}
                    {required && <sup style={{ color: "red" }}>*</sup>}
                </S.FormLabel>
            );
        }
        return null;
    };

    const _renderErrorTextIf = () => {
        if (hasError && errorText) {
            return (
                <S.FeedbackOtherLabel type="tooltip">
                    {errorText}
                </S.FeedbackOtherLabel>
            );
        }
        return null;
    };
    const _renderWarning = () => {
        // if (hasError && errorText) {
        return (
            <S.FeedbackOtherWarningLabel type="tooltip">
                {textBelow}
            </S.FeedbackOtherWarningLabel>
        );
        // }
        return null;
    };

    return (
        <>
            <Form.Group id={id} className="mb-4 formgroup">
                {_renderLabelIf()}
                <InputGroup>
                    {groupText && (
                        <InputGroup.Text id="basic-addon1">
                            {groupText}
                        </InputGroup.Text>
                    )}
                    <Form.Control
                        className="formcontrol shadow-none"
                        value={textValue}
                        onChange={onChange.bind(null, id)}
                        required={required}
                        type="number"
                        placeholder={placeholder}
                        disabled={disabled}
                        isInvalid={isInvalid}
                    />

                    <InputGroup>{_renderErrorTextIf()}</InputGroup>
                    <InputGroup>{_renderWarning()}</InputGroup>
                </InputGroup>
            </Form.Group>
        </>
    );
};

NumberInput.defaultProps = {
    required: false,
    disabled: false,
    hasError: false,
    isnegativeAllowed: true,
};
